import React, { useState, useEffect } from "react";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const LanguageSelector = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);

  const [testList, setTestList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [branchList, setBranchList] = useState([]);

  const [selectedState, setSelectedState] = useState("");
  const [selectedArea, setSelectedArea] = useState("");
  const [selectedBranch, setSelectedBranch] = useState("");

  const [testDetailsMap, setTestDetailsMap] = useState({});
  const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
  const [selectedLetter, setSelectedLetter] = useState("");
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);

useEffect(() => {
  const handleResize = () => setIsMobile(window.innerWidth <= 600);
  window.addEventListener("resize", handleResize);
  return () => window.removeEventListener("resize", handleResize);
}, []);

useEffect(() => {
  // Disable right click (desktop)
  const disableRightClick = (e) => e.preventDefault();
  document.addEventListener("contextmenu", disableRightClick);

  // Disable copy / cut / paste
  const blockCopy = (e) => e.preventDefault();
  document.addEventListener("copy", blockCopy);
  document.addEventListener("cut", blockCopy);
  document.addEventListener("paste", blockCopy);

  // Disable text selection
  const disableSelect = (e) => e.preventDefault();
  document.addEventListener("selectstart", disableSelect);

  // Disable long press (iPhone) but allow scroll
  let pressTimer;
  const preventLongPress = (e) => {
    pressTimer = setTimeout(() => {
      e.preventDefault();
    }, 350);
  };
  const clearPress = () => clearTimeout(pressTimer);

  document.addEventListener("touchstart", preventLongPress, { passive: false });
  document.addEventListener("touchend", clearPress);
  document.addEventListener("touchmove", clearPress);

  // Cleanup
  return () => {
    document.removeEventListener("contextmenu", disableRightClick);
    document.removeEventListener("copy", blockCopy);
    document.removeEventListener("cut", blockCopy);
    document.removeEventListener("paste", blockCopy);
    document.removeEventListener("selectstart", disableSelect);
    document.removeEventListener("touchstart", preventLongPress);
    document.removeEventListener("touchend", clearPress);
    document.removeEventListener("touchmove", clearPress);
  };
}, []);

  // Fetch States
  useEffect(() => {
    fetch(`${API_BASE_URL}test_maharashtra_details`)
      .then((res) => res.json())
      .then((data) => {
        if (data.STATUS) {
          setStateList(data.data);
          // default select first state if exists
          if (data.data.length === 1) setSelectedState(data.data[0].state_name);
        }
      })
      .catch(console.error);
  }, []);

  // Fetch Cities when State changes
  useEffect(() => {
    if (!selectedState) return;

    fetch(`${API_BASE_URL}test_city_pune_details/${selectedState}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.STATUS) {
          const cities = data.data.map((c) => c.territory_name);
          setCityList(cities);
          setSelectedArea(cities.length === 1 ? cities[0] : "");
        }
      })
      .catch(console.error);
  }, [selectedState]);

  // Fetch Branches when City changes
  useEffect(() => {
    if (!selectedArea) return;

    fetch(`${API_BASE_URL}test_city_details_pune/${selectedArea}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.STATUS) {
          const branches = data.data.map((b) => b.SysField);
          setBranchList(branches);
          setSelectedBranch(branches.length === 1 ? branches[0] : "");
        }
      })
      .catch(console.error);
  }, [selectedArea]);

  // Fetch Test Rates
  useEffect(() => {
    if (!selectedState || !selectedArea || !selectedBranch) return;

    const payload = {
      state: selectedState,
      territory: selectedArea,
      branch: selectedBranch,
      test_language: ["English"],
    };

    fetch(`${API_BASE_URL}test_rate_details_new`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    })
      .then((res) => res.json())
      .then((data) => {
        setTestList(data.STATUS ? data.data : []);
        setCurrentPage(1);
      })
      .catch(console.error);
  }, [selectedState, selectedArea, selectedBranch]);

  // Filtering + Pagination
  const filteredByLetter = selectedLetter
    ? testList.filter((item) => item.test_name.startsWith(selectedLetter))
    : testList;

  const filteredList = filteredByLetter.filter((item) =>
    item.test_name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const totalPages = Math.ceil(filteredList.length / itemsPerPage);
  const displayedItems = filteredList.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  // Popup & API Call
  const handleTestClick = (serviceId, branch) => {
    const existing = testDetailsMap[serviceId];
    if (existing?.open) {
      setTestDetailsMap((prev) => ({
        ...prev,
        [serviceId]: { ...prev[serviceId], open: false },
      }));
      return;
    }

    setTestDetailsMap({});

    fetch(`${API_BASE_URL}test_city_details_view?branch=${branch}&testcode=${serviceId}`)
      .then((res) => res.json())
      .then((data) => {
        const testDataArray = data.data?.data;
        if (data.STATUS && testDataArray?.length > 0) {
          setTestDetailsMap({
            [serviceId]: { open: true, details: testDataArray[0] },
          });
        }
      })
      .catch(console.error);
  };


  

  // Styles
  const styles = {
    container: {
      fontFamily: "Arial, sans-serif",
      minHeight: "100vh",
      background: "linear-gradient(135deg, #e0f7fa, #fce4ec)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: "20px",
      boxSizing: "border-box",
    },
    card: {
      backgroundColor: "#ffffff",
      padding: "30px 20px",
      borderRadius: "16px",
      width: "100%",
      maxWidth: "900px",
      boxShadow: "0 8px 20px rgba(0, 0, 0, 0.1)",
    },
    headerTop: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      flexWrap: "wrap",
      marginBottom: "20px",
    },
logo: { 
  width: isMobile ? "150px" : "265px",
  maxWidth: "100%",
  height: "auto"
},
    callLink: { textDecoration: "none", color: "#00796b", fontWeight: "bold", fontSize: "16px" },
    whatsappImg: { height: "28px", width: "28px" },
    group: { display: "flex", flexWrap: "wrap", justifyContent: "center", gap: "10px", marginTop: "10px" },
    button: (active) => ({
      padding: "8px 16px",
      borderRadius: "20px",
      border: "1px solid #00796b",
      backgroundColor: active ? "#00796b" : "#fff",
      color: active ? "#fff" : "#00796b",
      cursor: "pointer",
    }),
    label: { fontWeight: "bold", textAlign: "center", marginTop: "15px" },
    langButtonGroup: { display: "flex", flexWrap: "wrap", justifyContent: "center", gap: "10px", margin: "10px 0" },
    langButton: (active) => ({
      padding: "8px 16px",
      borderRadius: "20px",
      border: "1px solid #00796b",
      backgroundColor: active ? "#00796b" : "#fff",
      color: active ? "#fff" : "#00796b",
      cursor: "pointer",
    }),
    pagination: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      gap: "6px",
      marginTop: "20px",
      flexWrap: "wrap",
    },
    pageButton: {
      width: "40px",
      padding: "6px 0",
      textAlign: "center",
      fontSize: "16px",
      border: "1px solid #00796b",
      borderRadius: "6px",
      cursor: "pointer",
      backgroundColor: "#fff",
      color: "#00796b",
    },
    activePage: {
      width: "40px",
      padding: "6px 0",
      textAlign: "center",
      fontSize: "16px",
      backgroundColor: "#00796b",
      color: "#fff",
      border: "1px solid #00796b",
      borderRadius: "6px",
      cursor: "pointer",
    },
    title: {
      fontSize: '20px',
      color: '#00796b',
      textAlign: 'center',
      marginTop: '10px',
    },
     footer: {
      textAlign: 'center',
      marginTop: '20px',
      fontSize: '14px',
      color: '#777',
    },
    
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        {/* Header */}
        <div style={styles.headerTop}>
          <img src="assets/images/Logos.png" alt="VDC Logo" style={styles.logo} />
          <div style={styles.contactContainer}>
            <a href="tel:9240222222" style={styles.callLink}>📞 9240 222 222</a>
            <a href="https://api.whatsapp.com/send/?phone=919121999111&text&type=phone_number&app_absent=0" target="_blank" rel="noopener noreferrer">
              <img src="assets/images/wtsapp.png" alt="WhatsApp" style={styles.whatsappImg} />
            </a>
          </div>
        </div>
<h2 style={styles.title}>Vijaya Diagnostic Centre</h2>
        {/* State selection */}
        {stateList.length > 0 && (
          <div style={styles.group}>
            {stateList.map((state, i) => (
              <button
                key={i}
                style={styles.button(selectedState === state.state_name)}
                onClick={() => {
                  setSelectedState(state.state_name);
                  setSelectedArea("");
                  setSelectedBranch("");
                }}
              >
                {state.state_name}
              </button>
            ))}
          </div>
        )}

        {/* City selection */}
        {selectedState && cityList.length > 0 && (
          <div style={styles.group}>
            {cityList.map((city, i) => (
              <button
                key={i}
                style={styles.button(selectedArea === city)}
                onClick={() => {
                  setSelectedArea(city);
                  setSelectedBranch("");
                }}
              >
                {city}
              </button>
            ))}
          </div>
        )}

        {/* Branch selection */}
        {selectedArea && branchList.length > 0 && (
          <div style={styles.group}>
            {branchList.map((branch, i) => (
              <button
                key={i}
                style={styles.button(selectedBranch === branch)}
                onClick={() => setSelectedBranch(branch)}
              >
                {branch}
              </button>
            ))}
          </div>
        )}

        {/* Test list */}
        {selectedArea && selectedBranch && (
          <>
            <input
              style={{ width: "100%", padding: 10, marginTop: 20, borderRadius: 8, border: "1px solid #ccc" }}
              placeholder="Search test..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />

            <ul style={{ listStyle: "none", padding: 0, marginTop: 20 }}>
  {displayedItems.map((item, i) => {
    const testData = testDetailsMap[item.ServiceId];
    const isOpen = testData?.open;

    return (
      <li key={i} style={{ padding: "5px", marginBottom: "5px", background: "#f1f8e9", borderRadius: "8px", fontSize: "13px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", fontWeight: "bold", alignItems: "center" }}>
          <span>{item.test_name}</span>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <span>₹{Math.round(item.rate)}</span> {/* Removed .00 */}
            <span style={{ cursor: "pointer", fontSize: "20px" }} onClick={(e) => { e.stopPropagation(); handleTestClick(item.ServiceId, selectedBranch); }}>
              👁️
            </span>
          </div>
        </div>

       {isOpen && testData?.details && (
  <div 
    style={{ 
      marginTop: 10, 
      padding: "10px 12px", 
      background: "#fff", 
      borderRadius: 8, 
      border: "1px solid #ddd",
      position: "relative",   // Needed for watermark positioning
      overflow: "hidden"
    }}
  >
    {/* Watermark */}
    {/* {testData.details.IsServiceNABLAccreditation == 1 && (
      <img
        src="/assets/images/nabl.png"
        alt="NABL Watermark"
        style={{
          position: "absolute",
          right: 10,
          bottom: 10,
          width: 120,
          height: 120,
          opacity: 0.15,          // Transparent watermark
          pointerEvents: "none",   // So it doesn't block clicks
        }}
      />
    )} */}

    <p style={{ fontSize: "12px" }}><b>ServiceId:</b> {testData.details.ServiceId}</p>
    <p style={{ fontSize: "12px" }}><b>Service Code:</b> {testData.details.ServiceCode}</p>
    <p style={{ fontSize: "12px" }}><b>Service Name:</b> <b style={{color:"blue"}}>{testData.details.ServiceName}</b></p>
    <p style={{ fontSize: "12px" }}><b>VDC / Outsource:</b> {testData.details.VDC_Outsource === "Outsource" ? "Outsource" : "In house"}</p>
    <p style={{ fontSize: "12px" }}><b>Methodology:</b> {testData.details.Methodology}</p>
    <p style={{ fontSize: "12px" }}><b>Specimen Volume:</b> {testData.details.Specimen_Volume}</p>
    <p style={{ fontSize: "12px" }}><b>Container:</b> {testData.details.Container}</p>
    <p style={{ fontSize: "12px" }}><b>Patient Preparation:</b> {testData.details.Patient_Preparation}</p>
    <p style={{ fontSize: "12px" }}><b>Turn Around Time:</b> {testData.details.Daily_Schedule_Turn_Around_Time}</p>
    <p style={{ fontSize: "12px" }}><b>Shipment Temperature:</b> {testData.details.Shipment_Temperature}</p>
    <p style={{ fontSize: "12px" }}><b>MRP:</b> ₹{Math.round(testData.details.MRP)}</p>

    <p style={{ fontSize: "12px" }}>
      <b>NABL Accreditation:</b> {testData.details.IsServiceNABLAccreditation == 1 ? "Yes" : "No"}
    </p>
  </div>
)}
      </li>
    );
  })}
</ul>  
            {/* Alphabet Filter */}
            <div style={styles.langButtonGroup}>
              {alphabet.map((letter) => (
                <button key={letter} style={styles.langButton(selectedLetter === letter)} onClick={() => { setSelectedLetter(letter); setCurrentPage(1); }}>
                  {letter}
                </button>
              ))}
              <button style={styles.langButton(selectedLetter === "")} onClick={() => { setSelectedLetter(""); setCurrentPage(1); }}>
                All
              </button>
            </div>

            {/* Pagination */}
            <div style={styles.pagination}>
              <button
                style={styles.pageButton}
                disabled={currentPage === 1}
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              >
                ◀
              </button>
              {/* {Array.from({ length: totalPages }, (_, i) => (
                <button
                  key={i}
                  style={currentPage === i + 1 ? styles.activePage : styles.pageButton}
                  onClick={() => setCurrentPage(i + 1)}
                >
                  {i + 1}
                </button>
              ))} */}
              <button
                style={styles.pageButton}
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
              >
                ▶
              </button>
            </div>
          </>
        )}

        <div style={styles.footer}>

          <br />
          <br />
          For feedback: feedback@vijayadiagnostic.in
          <br />
          <br />
          <b>*Kindly reach our billing staff for tariff details as on date</b>
          <br />
          <br />
          <div style={{ display: 'flex', justifyContent: 'center', gap: '20px', flexWrap: 'wrap' }}>
            <a href="https://bit.ly/vdcappn" target="_blank" rel="noopener noreferrer">
              <img src="assets/images/playstore.png" alt="Download on Play Store" style={{ height: '40px' }} />
            </a>
            <a href="https://apple.co/3SwQoww" target="_blank" rel="noopener noreferrer">
              <img src="assets/images/appstore.png" alt="Download on App Store" style={{ height: '40px' }} />
            </a>

          </div>
          &copy; 2025 Vijaya Diagnostic Centre. All rights reserved.
        </div>
      </div>
      
    </div>
  );
};

export default LanguageSelector;
